import { AGENTS_PWA_URL, IDENTITY_WEBAPP_URL } from 'config';
import ROUTES from 'routes/constants';

export const containsRedirectingPath = (path) =>
  path && path.includes(ROUTES.REDIRECTING);

export const redirectToLoginPage = (redirectBack) => {
  if (containsRedirectingPath(window.location.pathname)) {
    // don't redirect if the current path is redirecting
    return;
  }
  const redirectUrl = getLoginUrlWithRedirect(redirectBack);
  window.location.replace(redirectUrl);
};

export function getLoginUrlWithRedirect(redirectPath) {
  const currentPath = window.location.pathname + window.location.search;
  let redirect = redirectPath?.toString() || currentPath;
  const redirectUrl = encodeURIComponent(`${AGENTS_PWA_URL}${redirect}`);

  redirect =
    redirect.endsWith('/') || redirect.includes(ROUTES.FORBIDDEN_PATH)
      ? `/auth/login?redirect=${AGENTS_PWA_URL}`
      : `/auth/login?redirect=${redirectUrl}`;

  return `${IDENTITY_WEBAPP_URL}${redirect}`;
}
